import React, { useState } from "react";
import { Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";

const Signup: React.FC = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
   const [menuOpen, setMenuOpen] =  useState(false);

  return (
    <>
      <MobileMenu
  isOpen={menuOpen}
  onClose={() => setMenuOpen(false)}
/>
      <PopupSearch />

      <main className="create-account-page">
        <Header />
<link rel="stylesheet" href="/assets/css/login.css" />
     

        {/* HERO */}
      {/* Breadcrumb */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage:
              "url('/assets/img/bg/breadcumb-bg-1.jpg')",
                backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
          }}
        >
          <img
            src="assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
            
          />

          <div className="container">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">Create Account</h1>

                <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li>
                    <a  href="javascript:void(0)">HOME</a>
                  </li>

                  <li>
Create Account</li>
                </ul>
              </div>
            </div>
          </div>
       
        </div>

        {/* FORM SECTION */}
        <section className="account-form-section">
          <div className="container">

            <div className="account-card">

              <h2 className="account-title">
                Create Account
              </h2>

              <p className="account-subtitle">
                Join Ninesister Jewels family
              </p>

              {/* SOCIAL LOGIN */}
              <button className="social-btn google-btn">
                {/* <img
                  src="https://cdn-icons-png.flaticon.com/512/300/300221.png"
                  alt=""
                /> */}
                  <i className="fa-brands fa-google"></i>

                <span>Sign up with Google</span>
              </button>

              <button className="social-btn facebook-btn">
                {/* <i className="fab fa-facebook-f"></i> */}
    <i className="fa-brands fa-facebook-f"></i>
                <span>Sign up with Facebook</span>
              </button>

              {/* DIVIDER */}
              <div className="divider">
                <span>or register with email</span>
              </div>

              {/* FORM */}
              <form>

                <div className="row">

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>First Name</label>

                      <input
                        type="text"
                        placeholder="Priya"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Last Name</label>

                      <input
                        type="text"
                        placeholder="Sharma"
                      />
                    </div>
                  </div>

                </div>

                <div className="form-group">
                  <label>Email Address</label>

                  <input
                    type="email"
                    placeholder="your@email.com"
                  />
                </div>

                <div className="form-group">
                  <label>Phone Number</label>

                  <input
                    type="text"
                    placeholder="+91 XXXXX XXXXX"
                  />
                </div>

                {/* PASSWORD */}
                <div className="form-group">
                  <label>Password</label>

                  <div className="password-field">

                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Min. 8 characters"
                    />

                    <i
                      className={`fa-regular ${
                        showPassword
                          ? "fa-eye-slash"
                          : "fa-eye"
                      }`}
                      onClick={() =>
                        setShowPassword(!showPassword)
                      }
                    ></i>

                  </div>
                </div>

                {/* CONFIRM PASSWORD */}
                <div className="form-group">
                  <label>Confirm Password</label>

                  <div className="password-field">

                    <input
                      type={
                        showConfirmPassword
                          ? "text"
                          : "password"
                      }
                      placeholder="Re-enter password"
                    />

                    <i
                      className={`fa-regular ${
                        showConfirmPassword
                          ? "fa-eye-slash"
                          : "fa-eye"
                      }`}
                      onClick={() =>
                        setShowConfirmPassword(
                          !showConfirmPassword
                        )
                      }
                    ></i>

                  </div>
                </div>

                {/* CHECKBOX */}
                <div className="checkbox-area">
                  <input type="checkbox" id="terms" />

                  <label htmlFor="terms">
                    I agree to the
                    <span> Terms & Conditions </span>
                    and
                    <span> Privacy Policy</span>
                  </label>
                </div>

                {/* BUTTON */}
                <button
                  type="submit"
                  className="vs-btn w-100"
                >
                  CREATE ACCOUNT
                </button>

                <p className="signin-text">
                  Already have an account?
                  <Link to="/login">
                    Sign in
                  </Link>
                </p>

              </form>
            </div>

          </div>
        </section>

        <Footer />
      </main>

      <ScrollToTop />
    </>
  );
};

export default Signup;